import { createUseStyles } from 'react-jss'

const useStyles = createUseStyles({
  icon: {
    height: 'auto',
    maxWidth: 40,
    maxHeight: 30,
    objectFit: 'contain'
  }
})

export default useStyles
